import script from "./integration-employee-card.vue?vue&type=script&setup=true&lang=js"
export * from "./integration-employee-card.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__